import React from 'react';
import { Layout, Text, Icon, Card, Button, BasicCard, useTheme } from '../../components/_primatives';
import { useQuery } from '@apollo/react-hooks';
import { Q_GET_SURVEY } from '../../data/api/query/q_survey';
import { FlatList, View, StyleSheet } from 'react-native';
import { SurveyCard, CardItem } from '../../components/list-items/CardItem';
import { AuthContext } from '../../App';
import { PageLoadingIndicator } from '../../components/LoadingIndicator';
import { useScreenDimensions } from '../../utils/useScreenInfo';
import { NoSurveyCard } from '../../components/surveys/NoSurveyCard';
import { BASE_TYPES } from '../../data/models/enums/base_types';
import { Survey } from '../../data/models/types';




export default function SurveyListScreen({ navigation }): React.ReactElement {
    const { pageSpacerHorizontal, bodyWidth, isMediumScreenOrLarger  } = useScreenDimensions();
    const theme = useTheme();
    const MAIN_COLOR: string = theme['color-primary-default'];
    const { user } = React.useContext(AuthContext);
    const { loading, error, data, refetch } = useQuery(Q_GET_SURVEY, {
        variables: {
            author_id: user.id,
            base_type: BASE_TYPES.SURVEY
        },
        fetchPolicy: 'network-only'
    });
    React.useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            // The screen is focused
            console.log('const unsubscribe = navigation.addListener(focus, () => refetch();')
            refetch();
        });

        // Return the function to unsubscribe from the event so it gets removed on unmount
        return unsubscribe;
    }, [navigation]);

    if (loading) return <PageLoadingIndicator />;
    if (error) {
        console.log('useQuery', error);
        return <Text>Error :(</Text>
    };

    console.log('we have data, ', data)


    const renderHeader = () => (
        <View style={{ marginVertical: 20, marginBottom: 30, paddingHorizontal: isMediumScreenOrLarger ? 0 : 23 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap' }}>
                <View>
                    <Text category='h1'>{'Surveys'}</Text>
                    <View style={{ width: 90, backgroundColor: MAIN_COLOR, height: 4 }}></View>
                </View>
                <Button
                    onPress={() => navigation.navigate('CreateSurvey')}
                    icon={(style) => <Icon {...style} name='plus' />}
                >
                    {isMediumScreenOrLarger ? `Create ` : ''}
                </Button>
            </View>
        </View>
    );
    const renderFooter = () => (
        <View style={{ height: 100 }}>
        </View>
    );
    const renderSurvey = ({ item }) => (
        <BasicCard onPress={() => navigation.navigate('Survey', { survey: item.id })} style={isMediumScreenOrLarger ? { marginBottom: 15 } : { borderWidth: 0 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', }}>
                <Icon name={'clipboard-outline'} style={{ marginRight: 20 }} height={25} width={25} fill='rgb(143, 155, 179)'/>
                <View style={{ flex: 1 }}>
                    <Text category='s1' style={{ fontWeight: 'bold' }}>{item.title}</Text>
                    <Text category='p1' appearance='hint'>{item.description}</Text>
                </View>
            </View>
        </BasicCard>
    );
    const listEmptyComponent = () => (
        <BasicCard style={{ marginBottom: 10, borderWidth: 0 }}>
            <NoSurveyCard
                subtitle={'No surveys found'}
                hideButton
            />
        </BasicCard>

    );
    const listItemSeparator = () => (
        <Layout level='4' style={{ height: 1 }}></Layout>
        // <View style={{ backgroundColor: 'red', height: 2 }}></View>
    );
    const keyExtractor = (item: CardItem) => item.id;
    

    return (
        <Layout level='1' style={{ flex: 1 }}>
            <FlatList
                data={data.surveys as Survey[]}
                renderItem={renderSurvey}
                keyExtractor={keyExtractor}
                ListHeaderComponent={renderHeader}
                ListFooterComponent={renderFooter}
                ListEmptyComponent={listEmptyComponent}
                style={{ flex: 1, paddingHorizontal: pageSpacerHorizontal }}
                contentContainerStyle={isMediumScreenOrLarger ? { width: bodyWidth, alignSelf: 'center', paddingTop: 0 } : undefined}
            />
        </Layout>
    );
}